const PREVIEW_TYPES = new Set([
  "PREVIEW_UNCAUGHT_EXCEPTION",
  "PREVIEW_UNHANDLED_REJECTION",
  "PREVIEW_CONSOLE_ERROR",
]);

export const PREVIEW_ERROR_CATCHER = `
(function () {
  function send(type, payload) { parent.postMessage(Object.assign({ type: type }, payload), "*"); }
  window.addEventListener("error", function (e) {
    send("PREVIEW_UNCAUGHT_EXCEPTION", { message: e.message, stack: e.error && e.error.stack });
  });
  window.addEventListener("unhandledrejection", function (e) {
    var r = e.reason;
    send("PREVIEW_UNHANDLED_REJECTION", { message: (r && r.message) || String(r), stack: r && r.stack });
  });
  var origErr = console.error;
  console.error = function () {
    try { send("PREVIEW_CONSOLE_ERROR", { args: Array.from(arguments) }); } catch (_) {}
    return origErr.apply(console, arguments);
  };
})();
`;

interface NodepodLike { setPreviewScript(script: string): Promise<void>; }

export async function installPreviewMessages(
  nodepod: NodepodLike,
  emit: (msg: { type: string; [k: string]: unknown }) => void,
): Promise<() => void> {
  await nodepod.setPreviewScript(PREVIEW_ERROR_CATCHER);
  const handler = (e: MessageEvent) => {
    const data = e.data;
    if (data && typeof data === "object" && PREVIEW_TYPES.has(data.type)) emit(data);
  };
  window.addEventListener("message", handler);
  return () => window.removeEventListener("message", handler);
}
